/** Brand mark for authentication and icon-only placements. */
export default function BrandMark({ size = 88, withWordmark = true }) {
  const source = withWordmark
    ? "/Design_3-transparent-full.png"
    : "/Design_3-transparent-icon.png";
  const width = withWordmark ? Math.round(size * 1.83) : Math.round(size * 0.88);

  return (
    <div className="flex items-center justify-center" data-testid="auth-brand-mark">
      <img
        src={source}
        alt="Guided Sentry"
        width={width}
        height={size}
        className="object-contain"
        draggable={false}
      />
    </div>
  );
}
